import api from '@/services/api'

const state = {}

const getters = {}

const actions = {
    export({}, data) {
        return new Promise( (resolve) => {
            api().post('/data/export', data).then( (response) => {
                resolve(response)
            })
        })
    },
}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/data.js